__turbopack_context__.v({
  "LargeImage": "LargeImage-module-sass-module__UhjAoG__LargeImage",
});
